import React from 'react';
import Image from 'swag-client-common/components/ui/image';
import classes from './preview-image.scss';
const PreviewImage = ({
  image
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.block
}, /*#__PURE__*/React.createElement(Image, {
  src: image,
  alt: "Customer`s mockup",
  wrapperClassName: classes.imageWrapper,
  className: classes.image,
  loadingClassName: classes.loadingPlaceholder
}));
export default PreviewImage;